import React from "react";
import { Helmet } from "react-helmet";

// Per-page title, description, canonical address and sharing tags (defaults live in public/index.html).
// Canonical is always https://newstand.tech + the page path, without query strings, so each page has one address.
const SITE = "https://newstand.tech";

const SEO = ({ title, description, url, image, noindex }) => {
  const path = typeof window !== "undefined" ? window.location.pathname : "/";
  const canonical = url && url.startsWith(SITE) ? url : `${SITE}${path}`;
  return (
    <Helmet>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      <link rel="canonical" href={canonical} />
      <meta property="og:url" content={canonical} />
      {title ? <meta property="og:title" content={title} /> : null}
      {description ? <meta property="og:description" content={description} /> : null}
      {image ? <meta property="og:image" content={image} /> : null}
      {title ? <meta name="twitter:title" content={title} /> : null}
      {description ? <meta name="twitter:description" content={description} /> : null}
      {image ? <meta name="twitter:image" content={image} /> : null}
      {noindex ? <meta name="robots" content="noindex, follow" /> : null}
    </Helmet>
  );
};

export default SEO;
